// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '3d4e2c4acb981ffaf6d326431cf131cc954607ed';
export const BUILD_NUMBER = '265';
export const BUILD_TIMESTAMP = '2026-10-13T03:52:44.653Z';
